export const VAT_COEFFICIENT = 1.1;
export const VAT_RATE_PERCENT = 10;

export const MIN_PLANNING_YEAR = 2025;
export const FUTURE_PLANNING_YEARS = 5;

export const getDefaultPlanningYear = (now = new Date()): number => now.getFullYear();
